import { render, staticRenderFns } from "./discord.vue?vue&type=template&id=6aa44748&scoped=true&"
import script from "./discord.vue?vue&type=script&lang=js&"
export * from "./discord.vue?vue&type=script&lang=js&"
import style0 from "./discord.vue?vue&type=style&index=0&id=6aa44748&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa44748",
  null
  
)

export default component.exports